import axios from "axios"

export const Get = function(path, headers) {
    if (!isValidArgs({ path: path, headers: headers })) {
        return
    }   
    return axios.get(path, { headers: headers })
}
export const Post = function(path, data, headers) {
    if (!isValidArgs({ path: path, data: data, headers: headers })) {
        return;
    }

    return axios.post(path, data, { headers: headers });
}

const isValidArgs = function(argObj) {
    if (argObj.path === null || typeof argObj.path !== "string" || argObj.path === "") {
        return false
    }

    if (typeof argObj.headers !== "undefined" && typeof argObj.headers !== "object") {
        return false
    }

    return true
}